import React, { useEffect, useState } from "react";
// import { RiCloseFill } from 'react-icons/ri';
// import TagInputs from "../layouts/TagInputs";
// import { usePatient } from "../../contexts";
// import SuccessModal from "../modals/SuccessModal";
// import { useNavigate } from "react-router-dom";
import ProcedureTable from "../tables/ProcedureTable";
import { get } from "../../utility/fetch";
import Spinner from "../UI/Spinner";
// import { Avatar, Box, Grid, Typography } from "@mui/material";
import {
  Box,
  Grid,
  Typography,
  Card,
  CardContent,
  Avatar,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Button,
  Skeleton
} from '@mui/material';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer
} from 'recharts';
import { MdAccountCircle as AccountCircleIcon } from "react-icons/md"; // Already using 'as'

import {
  MdFiberManualRecord as FiberManualRecordIcon, // Alias MdFiberManualRecord to FiberManualRecordIcon
  MdGroup as GroupIcon,                         // Alias MdGroup to GroupIcon
  MdHowToReg as HowToRegIcon,                   // Alias MdHowToReg to HowToRegIcon
  MdPersonAddAlt1 as PersonAddAlt1Icon,         // Alias MdPersonAddAlt1 to PersonAddAlt1Icon
  MdPendingActions as PendingActionsIcon        // Alias MdPendingActions to PendingActionsIcon
} from "react-icons/md";


// Your local components
import OutAndInpatientGraph from '../chart/OutAndInpatientGraph';
import ReferalByPatient from '../chart/ReferalByPatient';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

// If you uncomment this, ensure the path is correct
// import { get } from '../../utility/fetch';

const prescriptionTrend = [
  { name: 'Sun', value: 0 },
  { name: 'Mon', value: 10 },
  { name: 'Tue', value: 12 },
  { name: 'Wed', value: 40 },
  { name: 'Thu', value: 35 },
  { name: 'Fri', value: 30 },
  { name: 'Sat', value: 38 },
];

const prescriptionCategories = [
  { name: 'Malaria', count: 104, color: '#00C49F' },
  { name: 'Typhoid', count: 104, color: '#00C49F' },
  { name: 'Flu & Catarrh', count: 104, color: '#00C49F' },
  { name: 'Ante-Natal/Pregnancy', count: 104, color: '#00C49F' },
  { name: 'Injury/Clinical', count: 104, color: '#00C49F' },
];

const dummyGender = {
  pharmAPatientPercentage: 60,
  pharmBPatientPercentage: 40,
  pharmCPatientPercentage: 20,
  pharmDPatientPercentage: 10,
};

const StatCard = ({ label, number, icon }) => (
  <Card
    sx={{
      minHeight: 120,
      minWidth: 180,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      position: 'relative',
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
      '&:hover': {
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
        transform: 'translateY(-2px)',
        transition: 'all 0.3s ease'
      }
    }}
  >
    <Box sx={{ position: 'absolute', top: 16, left: 16, color: 'green.main' }}>
      {icon}
    </Box>
    <CardContent sx={{ textAlign: 'center', p: 3 }}>
      <Typography variant="h4" sx={{ fontWeight: 'bold', color: 'primary.main', mb: 1 }}>
        {number}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.85rem' }}>
        {label}
      </Typography>
    </CardContent>
  </Card>
);

const ChartCard = ({ title, children, dropdown = false }) => (
  <Card sx={{
    background: '#fff',
    padding: 2,
    borderRadius: 2,
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
    height: '100%'
  }}>
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
      <Typography variant="h6" sx={{ fontWeight: 'bold', fontSize: '1rem' }}>
        {title}
      </Typography>
      {dropdown && (
        <Typography variant="body2" color="text.secondary" sx={{ cursor: 'pointer' }}>
          Week ▼
        </Typography>
      )}
    </Box>
    {children}
  </Card>
);

function Dashboard() {
  const [allPatients, setAllPatients] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(true);
  const [showTable, setShowTable] = useState(false);
  const [summary, setSummary] = useState(null);
  const [graphData, setGraphData] = useState([]);
  const [referrals, setReferrals] = useState([]);
  const [referralsByPartner, setReferralsByPartner] = useState({});
  const [walkinReferral, setWakinReferral] = useState([]);
  const [walkInPercent, setWalkInPercent] = useState({});
  const [patientType, setPatientType] = useState('referred'); // Add this state
  const [walkInPatients, setWalkInPatients] = useState([]); // Add this state

  // Loading states
  const [isLoadingSummary, setIsLoadingSummary] = useState(true);
  const [isLoadingGraph, setIsLoadingGraph] = useState(true);
  const [isLoadingReferrals, setIsLoadingReferrals] = useState(true);
  const [isLoadingWalkinReferral, setIsLoadingWalkinReferral] = useState(true);

  const fulName = localStorage.getItem("firstName");
  const userId = sessionStorage.getItem("healthCareProviderId");
  const healthCareProvider = sessionStorage.getItem("healthCareProviderName");
  // const healthCareProvider = rawData ? JSON.parse(rawData) : null;

  // Default empty summary for when no data is available
  const defaultSummary = {
    numberOfPatients: 0,
    numberOfWalkInPatients: 0,
    numberOfReferredPatients: 0,
    numberOfPendingLabWork: 0
  };

  const fetchSummary = async () => {
    setIsLoadingSummary(true);
    try {
      const res = await get(`/dashboard/lab-summary?labId=${userId}`);
      setSummary(res && res.length > 0 ? res[0] : defaultSummary);
    } catch (e) {
      console.log("FAILED TO FETCH SUMMARY", e);
      setSummary(defaultSummary);
    } finally {
      setIsLoadingSummary(false);
    }
  };

  const fetchWalkinReferral = async () => {
    setIsLoadingWalkinReferral(true);
    try {
      const res = await get(`/dashboard/monthly-walkin-referral-count?labId=${userId}`);

      if (!res || res.length === 0) {
        setWakinReferral([]);
        setWalkInPercent({});
        return;
      }

      // Raw counts per month for chart
      const monthlyData = res.map(item => {
        const [year, month] = item.month.split('-');
        return {
          month: new Date(0, parseInt(month) - 1).toLocaleString('default', { month: 'short' }),
          walkIn: item.walkInCount || 0,
          referral: item.referralCount || 0
        };
      });

      setWakinReferral(monthlyData);

      // Total counts
      const totalWalkIn = res.reduce((sum, item) => sum + (item.walkInCount || 0), 0);
      const totalReferral = res.reduce((sum, item) => sum + (item.referralCount || 0), 0);
      const total = totalWalkIn + totalReferral;

      const percentageSplit = total > 0 ? {
        WalkIn: Math.round((totalWalkIn / total) * 100),
        Referral: Math.round((totalReferral / total) * 100)
      } : { WalkIn: 0, Referral: 0 };

      setWalkInPercent(percentageSplit);
    } catch (e) {
      console.log("FAILED TO FETCH WALK-IN/REFERRALS", e);
      setWakinReferral([]);
      setWalkInPercent({});
    } finally {
      setIsLoadingWalkinReferral(false);
    }
  };

  const fetchReferrals = async () => {
    setIsLoadingReferrals(true);
    try {
      const res = await get(`/dashboard/monthly-referrals?labId=${userId}`);

      if (!res || res.length === 0) {
        setReferrals([]);
        setReferralsByPartner({});
        return;
      }

      // Group by month
      const grouped = res.reduce((acc, curr) => {
        const [year, month] = curr.month.split('-');
        const monthName = new Date(0, parseInt(month) - 1).toLocaleString('default', { month: 'short' });

        if (!acc[monthName]) {
          acc[monthName] = 0;
        }
        acc[monthName] += curr.numberOfReferrals || 0;
        return acc;
      }, {});

      const chartData = Object.entries(grouped).map(([month, value]) => ({
        month,
        referrals: value
      }));

      setReferrals(chartData);

      // Group by partner (hospital)
      const groupedPartners = res.reduce((acc, curr) => {
        const { hospital, numberOfReferrals } = curr;
        if (!acc[hospital]) {
          acc[hospital] = 0;
        }
        acc[hospital] += numberOfReferrals || 0;
        return acc;
      }, {});

      const totalReferrals = Object.values(groupedPartners).reduce((a, b) => a + b, 0);

      if (totalReferrals > 0) {
        const percentageData = Object.entries(groupedPartners).reduce((acc, [hospital, count]) => {
          acc[hospital] = Math.round((count / totalReferrals) * 100);
          return acc;
        }, {});
        setReferralsByPartner(percentageData);
      } else {
        setReferralsByPartner({});
      }
    } catch (e) {
      console.log("FAILED TO FETCH REFERRALS", e);
      setReferrals([]);
      setReferralsByPartner({});
    } finally {
      setIsLoadingReferrals(false);
    }
  };

  // const fetchPatientBreakdown = async () => {
  //   setIsLoadingGraph(true);
  //   try {
  //     const res = await get(`/dashboard/monthly-patient-type-breakdown?labId=${userId}`);

  //     if (!res || res.length === 0) {
  //       // Set empty data for all 12 months
  //       const emptyData = Array.from({ length: 12 }, (_, i) => ({
  //         month: i + 1,
  //         outPatient: 0,
  //         inPatient: 0,
  //         referralPatient: 0,
  //         name: new Date(0, i).toLocaleString('default', { month: 'short' })
  //       }));
  //       setGraphData(emptyData);
  //       return;
  //     }

  //     const transformed = res.map(item => {
  //       const [year, month] = item.month.split('-');
  //       return {
  //         month: parseInt(month),
  //         outPatient: item.outpatients || 0,
  //         inPatient: item.inpatients || 0,
  //         referralPatient: item.referrals || 0
  //       };
  //     });

  //     const allMonths = Array.from({ length: 12 }, (_, i) => ({
  //       month: i + 1,
  //       outPatient: 0,
  //       inPatient: 0,
  //       referralPatient: 0
  //     }));

  //     const merged = allMonths.map(m => {
  //       const match = transformed.find(t => t.month === m.month);
  //       return {
  //         ...m,
  //         outPatient: match?.outPatient ?? 0,
  //         inPatient: match?.inPatient ?? 0,
  //         referralPatient: match?.referralPatient ?? 0,
  //         name: new Date(0, m.month - 1).toLocaleString('default', { month: 'short' })
  //       };
  //     });

  //     setGraphData(merged);
  //   } catch (e) {
  //     console.log("FAILED TO FETCH Breakdown", e);
  //     // Set empty data on error
  //     const emptyData = Array.from({ length: 12 }, (_, i) => ({
  //       month: i + 1,
  //       outPatient: 0,
  //       inPatient: 0,
  //       referralPatient: 0,
  //       name: new Date(0, i).toLocaleString('default', { month: 'short' })
  //     }));
  //     setGraphData(emptyData);
  //   } finally {
  //     setIsLoadingGraph(false);
  //   }
  // };

  useEffect(() => {
    fetchReferrals();
    fetchPatientBreakdown();
    fetchSummary();
    fetchWalkinReferral();
  }, []);

  // Helper function to check if data is empty
  const isDataEmpty = (data) => {
    if (Array.isArray(data)) {
      return data.length === 0;
    }
    if (typeof data === 'object') {
      return Object.keys(data).length === 0;
    }
    return !data;
  };


  // const fetchSummary = async () => {
  //   try {
  //     const res = await get(`/dashboard/lab-summary?labId=3`);
  //     setSummary(res[0]);
  //   } catch (e) {
  //     console.log("FAILED TO FETCH SUMMARY", e);
  //   }
  // };

  const fetchPatientBreakdown = async () => {
    try {
      const res = await get(`/dashboard/monthly-patient-type-breakdown?labId=${userId}`);

      const transformed = res.map(item => {
        const [year, month] = item.month.split('-');
        return {
          month: parseInt(month),
          outPatient: item.outpatients || 0,
          inPatient: item.inpatients || 0
        };
      });

      const allMonths = Array.from({ length: 12 }, (_, i) => ({
        month: i + 1,
        outPatient: 0,
        inPatient: 0
      }));

      const merged = allMonths.map(m => {
        const match = transformed.find(t => t.month === m.month);
        return {
          ...m,
          outPatient: match ? match.outPatient : 0,
          inPatient: match ? match.inPatient : 0,
          name: new Date(0, m.month - 1).toLocaleString('default', { month: 'short' })
        };
      });

      setGraphData(merged);
    } catch (e) {
      console.log("FAILED TO FETCH Breakdown", e);
    }
  };

  const getReferredPatients = async () => {
    setLoading(true);
    let res = await get('/referredpatient/list')

    if (res?.statusCode === 200) {
      // notification({ message: res?.data?.message, type: "success" });
      setAllPatients(res.data);
      setTotalPages(res?.metadata?.pageCount);
      console.log(res)
      setLoading(false);
    }
    else {
      // console.error('Error fetching all patients:', res?.data?.message);
      setLoading(false);
      // notification({ message: res?.data?.message, type: "error" });
    }
    console.log(res)
  }

  // Add this function to fetch walk-in patients
  const getWalkInPatients = async () => {
    setLoading(true);
    try {
        let res = await get('/walkinpatientlabreport/list/1/100');
        if (res) {
          console.log(res)
            setWalkInPatients(res.resultList);
            setTotalPages(res?.paginationMetadata?.totalPages);
            setLoading(false);
        } else {
            setLoading(false);
        }
    } catch (error) {
        console.error('Error fetching walk-in patients:', error);
        setLoading(false);
    }
};

  // Modify your existing useEffect
  useEffect(() => {
    if (patientType === 'referred') {
      getReferredPatients();
    } else {
      getWalkInPatients();
    }
    fetchPatientBreakdown();
    fetchSummary();
  }, [patientType]); // Add patientType as dependency

  // Add toggle handler
  const handleToggleChange = (event, newValue) => {
    if (newValue !== null) {
        setPatientType(newValue);
    }
};

  return (
    <div className="w-100 m-t-40">
      <div className="m-t-20">
        <div className="flex space-between">
          <h2 className="bold-text">Dashboard</h2>
          <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
            {showTable && (
              <ToggleButtonGroup
                value={patientType}
                exclusive
                onChange={handleToggleChange}
                aria-label="patient type"
                size="small"
            >
                <ToggleButton 
                  value="referred" 
                  aria-label="referred patients"
                  sx={{ 
                    '&.Mui-selected': { 
                      backgroundColor: '#1C811C',
                      color: 'white',
                      '&:hover': {
                          backgroundColor: '#166816'
                      }
                    }
                  }}
                >
                  Referred Patients
                </ToggleButton>
                <ToggleButton 
                  value="walkin" 
                  aria-label="walk-in patients"
                  sx={{ 
                    '&.Mui-selected': { 
                      backgroundColor: '#1C811C',
                      color: 'white',
                      '&:hover': {
                          backgroundColor: '#166816'
                      }
                    }
                  }}
                >
                  Walk-in Patients
                </ToggleButton>
            </ToggleButtonGroup>
            )}
            {/* <Button
              variant="contained"
              className="btn btn-primary"
              sx={{ backgroundColor: "green", fontSize: '0.875rem' }}
              onClick={() => setShowTable(!showTable)}
            >
              {showTable ? "Hide Table" : "Show Table"}
            </Button> */}
          </div>
        </div>
        {/* <h2>Dashboard</h2> */}
        {
            showTable ?
              <ProcedureTable 
                loading={loading} 
                readOnly={true} 
                data={patientType === 'referred' ? allPatients : walkInPatients} 
                isWalkin = {patientType === 'walkin'}
              />
              :
              <Box sx={{ p: { xs: 2, md: 4 }, minHeight: '100vh' }}>
                <Grid container justifyContent="space-between" alignItems="center" sx={{ mb: 4 }}>
                  <Grid item display="flex" alignItems="center">
                    <Avatar sx={{ width: 64, height: 64, mr: 3, backgroundColor: 'primary.main' }}>
                      <AccountCircleIcon fontSize="large" />
                    </Avatar>
                    <Box>
                      <Typography variant="subtitle2" color="text.secondary">Good Day</Typography>
                      <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 0.5 }}>
                        Dr. {fulName}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {healthCareProvider || 'Healthcare Provider'}.
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>

                <Grid container spacing={3} sx={{ mb: 4 }}>
                  <Grid item xs={12} sm={6} md={3}>
                    <StatCard
                      label="Total Patients"
                      number={summary?.numberOfPatients || 0}
                      icon={<GroupIcon sx={{ color: 'green' }} />}
                      isLoading={isLoadingSummary}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <StatCard
                      label="Walk-in Patients"
                      number={summary?.numberOfWalkInPatients || 0}
                      icon={<HowToRegIcon sx={{ color: 'green' }} />}
                      isLoading={isLoadingSummary}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <StatCard
                      label="Referred Patients"
                      number={summary?.numberOfReferredPatients || 0}
                      icon={<PersonAddAlt1Icon sx={{ color: 'green' }} />}
                      isLoading={isLoadingSummary}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <StatCard
                      label="Pending Lab Work"
                      number={summary?.numberOfPendingLabWork || 0}
                      icon={<PendingActionsIcon sx={{ color: 'green' }} />}
                      isLoading={isLoadingSummary}
                    />
                  </Grid>
                </Grid>

                <div className="graph-section">
                  <div className="graph-container">
                    {isLoadingGraph ? (
                      <Card sx={{ p: 2, height: 400 }}>
                        <Skeleton variant="text" width={200} height={30} sx={{ mb: 2 }} />
                        <Skeleton variant="rectangular" width="100%" height={350} />
                      </Card>
                    ) : (
                      <OutAndInpatientGraph propdata={graphData} />
                    )}
                  </div>
                  <div className="gender-container">
                    {isLoadingReferrals ? (
                      <Card sx={{ p: 2, height: 400 }}>
                        <Skeleton variant="text" width={200} height={30} sx={{ mb: 2 }} />
                        <Skeleton variant="circular" width={200} height={200} sx={{ mx: 'auto' }} />
                      </Card>
                    ) : (
                      <ReferalByPatient propData={referralsByPartner} title={"Referrals by Partners"} />
                    )}
                  </div>
                </div>

                <div className="graph-section2">
                  <ChartCard
                    title="Walk-in vs Referral per Month"
                    isLoading={isLoadingWalkinReferral}
                    isEmpty={isDataEmpty(walkinReferral)}
                  >
                    <ResponsiveContainer width="100%" height={200}>
                      <LineChart data={walkinReferral}>
                        <XAxis dataKey="month" />
                        <YAxis />
                        <Tooltip />
                        <Line
                          type="monotone"
                          dataKey="walkIn"
                          stroke="#00C49F"
                          strokeWidth={3}
                          dot={{ r: 4 }}
                          name="Walk-In"
                        />
                        <Line
                          type="monotone"
                          dataKey="referral"
                          stroke="#8884d8"
                          strokeWidth={3}
                          dot={{ r: 4 }}
                          name="Referral"
                        />
                      </LineChart>
                    </ResponsiveContainer>
                  </ChartCard>

                  <ChartCard
                    title="Referrals by Month"
                    isLoading={isLoadingReferrals}
                    isEmpty={isDataEmpty(referrals)}
                  >
                    <ResponsiveContainer width="100%" height={200}>
                      <LineChart data={referrals}>
                        <XAxis dataKey="month" />
                        <YAxis />
                        <Tooltip />
                        <Line
                          type="monotone"
                          dataKey="referrals"
                          stroke="#8884d8"
                          strokeWidth={3}
                          dot={{ r: 4, stroke: '#8884d8', strokeWidth: 2 }}
                          activeDot={{ r: 6, fill: '#8884d8' }}
                        />
                      </LineChart>
                    </ResponsiveContainer>
                  </ChartCard>

                  <div className="gender-container">
                    {isLoadingWalkinReferral ? (
                      <Card sx={{ p: 2, height: 400 }}>
                        <Skeleton variant="text" width={200} height={30} sx={{ mb: 2 }} />
                        <Skeleton variant="circular" width={200} height={200} sx={{ mx: 'auto' }} />
                      </Card>
                    ) : (
                      <ReferalByPatient propData={walkInPercent} title={"Walk-in vs Referrals"} />
                    )}
                  </div>
                </div>
              </Box>
        }
      </div>
    </div>
  );
}

export default Dashboard;
